import React from "react";
import { useTranslation } from "react-i18next";
import AuthPage from "./AuthPage.jsx";

export default function NewPasswordForm({
  password,
  setPassword,
  handleChallengeResponse,
}) {
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    handleChallengeResponse(password);
  };

  return (
    <AuthPage title={t("newPasswordTitle")} subtitle={t("newPasswordSubtitle")}>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label
            htmlFor="new-password"
            className="text-sm font-medium text-slate-700"
          >
            {t("newPassword")}
          </label>
          <input
            id="new-password"
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 shadow-sm outline-none transition focus:border-sky-600 focus:ring-2 focus:ring-sky-200"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full rounded-lg bg-sky-600 px-4 py-3 font-semibold text-white transition hover:bg-sky-700"
        >
          {t("confirm")}
        </button>
      </form>
    </AuthPage>
  );
}
